import { useEffect } from "react";
import LandingPage from "./pages/landingPage";

function App() {
  useEffect(() => {
    const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? "dark" : "light";
    const localTheme = localStorage.getItem("theme") || systemTheme;
    localStorage.setItem("theme", localTheme);
    document.querySelector("html").setAttribute("data-theme", localTheme);
  }, []);

  return (
    <>
      <LandingPage />
    </>
  );
}

export default App;
